export interface DisposableStore {
  dispose(): void;
}

export interface LazyStore extends DisposableStore {
  lazyEnable(): void;
}

export const isDisposableStore = (store: unknown): store is DisposableStore => {
  return (
    store !== null &&
    typeof store === "object" &&
    typeof (store as DisposableStore).dispose === "function"
  );
};

export const isLazyStore = (store: unknown): store is LazyStore => {
  return (
    store !== null &&
    typeof store === "object" &&
    typeof (store as LazyStore).lazyEnable === "function"
  );
};
